import {
  componentNameValidationMixin,
  createProxy,
  createStyleMixin,
  draggableMixin,
} from '@descope-ui/common/components-mixins';
import { getComponentName } from '@descope-ui/common/components-helpers';
import { ImageClass } from '@descope-ui/descope-image/class';
import { compose } from '@descope-ui/common/utils';

export const componentName = getComponentName('icon');

export const IconClass = compose(
  createStyleMixin({
    mappings: {
      fill: [{}, { property: ImageClass.cssVarList.fill }],
      height: { selector: () => ':host' },
      width: { selector: () => ':host' },
    },
  }),
  draggableMixin,
  componentNameValidationMixin,
)(
  createProxy({
    slots: [],
    wrappedEleName: 'descope-image',
    style: () => `
      :host {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        max-height: 100%;
      }
      `,
    excludeAttrsSync: ['tabindex', 'class', 'style', 'st-height', 'st-width'],
    componentName,
  }),
);
